module.exports = __webpack_public_path__ + "img/gift-coupon.574ef528.png";